import type { BatchStatus } from '@cartwhl/common/api/getBatch';
import type { ResponsiveSectionLayoutSection } from '@cartwhl/ui/layout/ResponsiveSectionLayout';

export const DASHBOARD_SECTION_SLUGS = [
  'dashboard',
  'library',
  'api-keys',
  'download-history',
  'admin',
] as const;

export type DashboardSectionSlug = (typeof DASHBOARD_SECTION_SLUGS)[number];

export interface DashboardSection
  extends ResponsiveSectionLayoutSection<DashboardSectionSlug> {}

export interface DashboardAppletCardData {
  id: string;
  path: string;
  external?: boolean;
  title: string;
  description: string;
  imageSrc?: string;
  imageAlt?: string;
  videoSrc?: string;
  badge?: string;
  disabled?: boolean;
}

export type DashboardWorkItemKind =
  | 'canvas-project'
  | 'scene'
  | 'comic-job'
  | 'swing-job'
  | 'mascot-job'
  | 'character-job';
export type DashboardWorkItemScope = 'mine' | 'team';
export type DashboardWorkFilter = DashboardWorkItemScope;
export type DashboardHomeTab = DashboardWorkFilter | 'getting-started';
export type DashboardWorkTypeFilter = 'all' | DashboardWorkItemKind;

export function isDashboardWorkFilter(
  tab: DashboardHomeTab,
): tab is DashboardWorkFilter {
  return tab === 'mine' || tab === 'team';
}

export function isDashboardHomeTab(
  value: string | null,
): value is DashboardHomeTab {
  return value === 'mine' || value === 'team' || value === 'getting-started';
}

export interface DashboardWorkItem {
  id: string;
  kind: DashboardWorkItemKind;
  scope: DashboardWorkItemScope;
  title: string;
  href: string;
  external?: boolean;
  thumbnailSrc?: string;
  createdByUser?: string;
  kindLabel:
    | 'Canvas Project'
    | 'Cartwheel Scene'
    | 'Comic job'
    | 'Swing job'
    | 'Mascot job'
    | 'Character batch';
  createdAt: string;
  updatedAt: string;
  itemCount?: number;
  batchStatus?: BatchStatus;
}

export interface DashboardWorkItemsData {
  items: DashboardWorkItem[];
}

export interface DashboardWorkSection {
  id: string;
  title: string;
  items: DashboardWorkItem[];
}
